import { ErrorCode } from "~/enum/ErrorCode";
import LoginResult from "../models/LoginResult";
import { createSnackbarNotification } from "@frontiers/brink-ui";
import { useConfigurationStore } from "~/stores/configurationStore";
import { navigateTo } from "nuxt/app";
import ErrorMessages from "~/helpers/ErrorMessages";

export class LinkAccountService {
    public static async LinkAccount(loginAuthenticationToken: string): Promise<void> {
        try {
            const configurationStore = useConfigurationStore();
            const configuration = configurationStore.config;
            const response = await fetch("/api/onboarding-ui/v1/email/terms-and-conditions/accept", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ loginAuthenticationToken })
            });

            if (response.ok) {
                const loginResult = new LoginResult(await response.json());

                if (loginResult.LoginResultAction == "1") {
                    if (loginResult.returnUrl) {
                        navigateTo(loginResult.returnUrl, { external: true });
                    } else {
                        throw new Error("Account linked but no returnUrl found after logging in.");
                    }
                }
            }
            else {
                const errorResult = await response.json();
                const errorCode = errorResult.Code;

                if (errorCode == ErrorCode.UserSuspended) {
                    navigateTo("/people/login");
                    createSnackbarNotification({
                        message: ErrorMessages.getMessage(ErrorCode.UserSuspended),
                        type: "error",
                        autoDismiss: true,
                        showCloseIcon: true,
                        actionLabel: "Contact support team",
                        onActionClick: () => {
                            window.location.href = `mailto:${configuration.domainProperties.supportEmail}`;
                        }
                    });
                    newrelic.noticeError('Suspended user has linked account');
                }
                else if (errorCode == ErrorCode.AccountInactiveOrNotVerified) {
                    navigateTo("/register/code-validation");
                }
            }
        } catch (e) {
            console.error("Error posting login (LinkAccount): " + e);
            throw e;
        }
    }
}